export enum ExchangeCostState {
  None,
  Equal,
  Up,
  Down,
}
